import React from "react";

// reactstrap components
import {
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import PrecEditionNavbar from "components/Navbars/PrecEditionNavbar.js";
import PrecEditionHeader from "components/Headers/PrecEditionHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

function PrecEdition() {
  React.useEffect(() => {
    document.body.classList.add("precedition-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("precedition-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const afficheArray = Array.from(Array(13).keys(), n => 2019 - n);
  console.log(afficheArray)

  return (
    <>
      <PrecEditionNavbar />
      <div className="wrapper">
        <PrecEditionHeader />
        <div className="section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="6">
                <h4 className="title text-center">Les précédentes années</h4>
                <TabPane tabId="pills1">
                  <Col className="ml-auto mr-auto" md="10">
                    <Row className="collections">
                      {afficheArray.map((afficheID) => {
                      return <Col key={afficheID} md="6">
                                <img
                                  alt="..."
                                  className="img-raised"
                                  src={require("assets/img/affiche" + afficheID + ".png").default}
                                ></img>
                              </Col>
                      })}
                    </Row>
                  </Col>
                </TabPane>
              </Col>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default PrecEdition;
